<template>
  <div class="doubele-eleven ">
    <province-list-dialog
      v-if="activityFloorInfo.product_filter"
      class="regular-activity-province"
      v-model="peerProvinceCode"
    >常住地</province-list-dialog>

    <template v-for="(item,index) in activityFloorInfo.activity_floor">
      <div
        :key="index"
        v-if="item.floor_type === 1&&item.pc_floor_image"
        class="floor-img-box"
        :style="{backgroundColor: item.background_color}"
      >
        <img
          class="floor-img"
          :src="item.pc_floor_image"
          @click="goUrl(item.pc_jump_link)"
        >
      </div>
      <div
        :key="index"
        v-if="item.floor_type === 2"
        class="product-box"
        :style="{backgroundColor: item.background_color}"
      >
        <img
          v-if="item.pc_floor_image"
          class="floor-img"
          :src="item.pc_floor_image"
          @click="goUrl(item.pc_jump_link)"
        >
        <div class="product-box-inner">
          <div class="product-list" :class="{'one':item.pc_per_row_number === 1,'two':item.pc_per_row_number === 2,'three':item.pc_per_row_number === 3,'four':item.pc_per_row_number === 4}">
            <product-item
              class="product-item-box"
              v-for="produtItem in item.productInfo.total_data"
              :key="produtItem.id"
              :product="produtItem"
              :activityFloorInfo="activityFloorInfo"
              :floorInfo="item"
              :activity-id="id"
            ></product-item>
          </div>
        </div>
      </div>
      <div
        :key="index"
        v-if="item.floor_type === 3"
        class="coupon-box"
        :style="{backgroundColor: item.background_color}"
      >
        <img
          v-if="item.pc_floor_image"
          class="floor-img"
          :src="item.pc_floor_image"
          @click="goUrl(item.pc_jump_link)"
        >
        <div class="coupon-list-box" :class="{'one':item.pc_per_row_number === 1,'two':item.pc_per_row_number === 2,'three':item.pc_per_row_number === 3,'four':item.pc_per_row_number === 4}">
          <div class="coupon-list">
            <coupon-item
              v-for="coupon in item.couponInfo.total_data"
              :key="coupon.id"
              :coupon="coupon"
              :activityFloorInfo="activityFloorInfo"
              :floorInfo="item"
              @updateCurrentCouponInfo="updateCurrentCouponInfo"
            ></coupon-item>
          </div>

        </div>
      </div>

    </template>
  </div>
</template>

  <script>
  import { Loading } from 'element-ui';
  import { mapMutations, mapActions, mapState } from 'vuex';
  import sensorsdata from 'sa-sdk-javascript';
  import ProductItem from './components/product-item.vue';
  import CouponItem from './components/coupon-item.vue';
  import User from '../../../libs/user';
  import utils from '../../../libs/utils';
  import provinceListDialog from '../../../components/common/province-list-dialog.vue';
  import peerApi from '../../../api/peer-api';
  import dailyActivityApi from '../../../api/daily-activity-api';

  // 双十一活动
  export default {
    name: '',
    components: {
      ProductItem,
      provinceListDialog,
      CouponItem,
    },
    data() {
      return {
        peerProvinceCode: 0, // 同业地址-省份
        id: '', // 活动ID
        sence: '', // 活动渠道
        activityFloorInfo: {},
      };
    },
    computed: {
      ...mapState('user', ['peerData']),

    },
    async created() {
      this.id = +this.$route.query.id || ''; // 活动id
      this.sence = this.$route.query.cno || ''; // 活动渠道
      if (!this.id) return;
      this.getPeerInfo();
    },
    destroyed() {
      clearInterval(this.timer);
    },
    methods: {
      ...mapMutations(['SHOW_LOGIN_BOX']),
      ...mapActions('user', [
        'getIPLocation',
      ]),
      async getActivityFloorList() {
        const id = this.id;
        const sence = this.sence;
        const province_code = this.peerProvinceCode;
        const result = await dailyActivityApi.getActivityInfo({ id, sence, province_code });
        result.activity_floor = result.activity_floor.map(item => ({ ...item, productInfo: {}, couponInfo: {} }));
        this.activityFloorInfo = result;

        const activity_floor = this.activityFloorInfo.activity_floor;
        for (let i = 0; i < activity_floor.length; i++) {
          const item = activity_floor[i];
          if (item.floor_type === 2) {
            // eslint-disable-next-line no-await-in-loop
            const info = await this.getFloorProducInfo(item.id);
            this.activityFloorInfo.activity_floor[i].productInfo = info;
          }
          if (item.floor_type === 3) {
            // eslint-disable-next-line no-await-in-loop
            const info = await this.getFloorCouponInfo(item.id);
            this.activityFloorInfo.activity_floor[i].couponInfo = info;
          }
        }
        this.setSensors();
        this.activityTips();
        this.setTitle(this.activityFloorInfo.title);
      },
      setTitle(title) {
        document.title = title;
      },
      // 活动提示
      activityTips() {
        const nowDate = Date.parse(new Date());
        const startTimeString = Date.parse(this.activityFloorInfo.start_time);
        const endTimeString = Date.parse(this.activityFloorInfo.end_time);
        if (+nowDate < +startTimeString) {
          this.$message.error('活动未开始哦，请稍后再来');
          return;
        }
        if (+nowDate > +endTimeString) {
          this.$message.error('活动已结束，请下次再来');

        }

      },
      setSensors() {
        if (User.isLogin() && this.activityFloorInfo.channel) {
          sensorsdata.track('ActivityView', {
            activity_id: this.activityFloorInfo.id,
            activity_name: this.activityFloorInfo.title,
            scene_name: this.activityFloorInfo.channel.channel_name,
            scene_code: this.activityFloorInfo.channel.channel_no,
            platform_type: 'PC',
            peer_name: User.peer_name,
            visa_peer_id: User.visa_peer_id,
          });
          console.log('获取同业信息', User);
        }
      },
      // 获取单独楼层的信息 类型是商品
      async getFloorProducInfo(floor_id) {
        const result = await dailyActivityApi.getFloorProducInfo({ id: this.id, floor_id, province_code: this.peerProvinceCode });
        return result;
      },
      // 获取单独楼层的信息 类型是优惠券
      async getFloorCouponInfo(floor_id) {

        const result = await dailyActivityApi.getFloorCouponInfo({ id: this.id, floor_id });
        return result;
      },

      // 更新当前优惠券状态
      async updateCurrentCouponInfo(data) {
        const { floorIndex, info } = data;
        this.activityFloorInfo.activity_floor[floorIndex].couponInfo = info;
      },
      // 领取优惠券
      async receiveCoupon(floorIndex, coupon) {
        // 未登录跳转到登录
        if (!User.isLogin()) {
          this.SHOW_LOGIN_BOX({ from: 'activity_double_eleven' });
          return;
        }
        const loadingInstance = Loading.service({
          text: '领取中',
        });
        try {
          await dailyActivityApi.receiveCoupon({ id: coupon.coupon_id });
          utils.msg.success('领取成功');
          this.updateCurrentCouponInfo(floorIndex, coupon.coupon_id);
          loadingInstance.close();
        } catch (err) {
          loadingInstance.close();
        }
      },
      getPeerInfo() {
        return new Promise(async (resolve) => {
          if (!User.isLogin()) {
            this.getIPLocation().then((res) => {
              this.peerProvinceCode = +res.province_code;
              resolve(res.province_code);
            });
          } else {
            const result = await peerApi.getPeerInfo();
            this.peerProvinceCode = result.province_code;
            resolve(this.peerProvinceCode);
          }

        });
      },
      // 跳转链接
      goUrl(url) {
        if (!url) return;
        window.open(url, '_blank');
      },
    },
    watch: {
      peerProvinceCode(val) {
        if (val) {
          this.getActivityFloorList();
        }
      },
    },
  };
  </script>

  <style scoped lang="less">
  .regular-activity-province.province-box{
    position: absolute;
    top: 135px;
    right: 80px;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 20px;
    /deep/ .filter-label .location-text{
      color: #fff;
    }
  }
  .doubele-eleven{
    line-height: 1;
    font-size: 0;
    .floor-img-box{
      display: flex;
      justify-content: center;
    }
    .floor-img{
      width: 100%;
      height: auto;
      margin: 0 auto;
    }
    .coupon-box{
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 8px;
      .coupon-list-box{
        display: flex;
        flex-direction: column;
        width: 1120px;
        margin:0 auto;
        .coupon-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }

        &.one{
          width: 940px;
          display: flex;
          flex-direction: column;
          padding: 0px;
          /deep/ .coupon-item{
            background: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-1.png) no-repeat center / 100% 100%;
            display: flex;
            justify-content: flex-start;
            width: 100%;
            margin-bottom: 20px;
            flex-direction:row;
            height: 166px;
            align-items: stretch;
            margin-right: 0px;
            .coupon-top{
              display: flex;
              justify-content: flex-start;
            }
            .coupon-bottom{
              margin-top: 6px;
              width: 160px;
              height: 120px;
              display: flex;
              justify-content: center;
              align-items: center;
              align-self: center;
              text-align: center;
            }
            .coupon-left{
              width: 261px;
              padding-left: 10px;
              position: relative;
              &::after{
                content: '';
                width: 0px;
                height: 121px;
                border-right: 1px dashed #D28E6B;
                position: absolute;
                top: 23px;
                right: 0px;
              }
            }
            .coupon-dec{
              align-items: flex-start;
              padding-left: 23px;
              margin-top: 0px;
            }
            .disabled-receive,.before-receive{
              color: rgba(225, 225, 225, 0.5);
            }
            .disabled-receive{
              font-size: 28px;
              line-height: 40px;
            }
            .goods-category{
              margin-top: 0;
              font-size: 32px;
              font-weight: bold;
              text-align: left;
            }
            .limit-product-text{
              font-weight: initial;
              font-size: 22px;
            }
            .max-price{
              font-size: 32px;
            }

            .allow-receive{
              width: auto;
              height: auto;
              .allow-img{
                width: 120px;
                height: 120px;
                background-color: transparent;
              }
            }
            .received{
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 28px;
              font-weight: 600;
              width: 100%;
              height: 100%;
            }

            .received-text{
              margin-top: -10px;
            }
            .coupon-country{
              position: initial;
              /* left: 0%; */
              transform: translateX(0%);
              text-align: left;
              padding-left: 0px;
              font-size: 24px;
              margin-top: 16px;
              text-align: left;
            }
            .allow-receive{
              background-color: transparent;
            }
            .coupon-country{
              background-color: transparent;
            }
            .single-show{
              .limit-product-text{
                font-size: 32px;
                font-weight: bold;
              }
            }
            &.disabled{
              background: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-2.png) no-repeat center / 100% 100%;
              .disabled-receive,.before-receive{
                color: rgba(225, 225, 225, 0.6);
              }
            }
          }
        }
        &.two{
          padding: 0 200px;
          /deep/ .coupon-item{
            padding-top: 60px;
            width: 344px;
            height: 277px;
            margin-right: 30px;
            margin-bottom: 30px;
            background-image: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-7.png);
            &.disabled{
              background-image: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-8.png);
              .coupon-country{
                background: rgba(255, 223, 185, 0.6);
              }
            }
            &:nth-child(2n){
              margin-right: 0px;
            }
            .coupon-country{
              width: 220px;
              background: #FFDFB9;
            }
            .limit-product-text{
              font-weight: initial;
              font-size: 22px;
            }
          }

        }
        &.three{
          padding: 0 200px;
          /deep/ .coupon-item{
            padding-top: 56px;
            width: 220px;
            height: 274px;
            margin-right: 30px;
            margin-bottom: 30px;
            background-image: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-5.png);
            &.disabled{
              background-image: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-6.png);
              .coupon-country{
                background: rgba(255, 223, 185, 0.6);
              }
            }
            &:nth-child(3n){
              margin-right: 0px;
            }
            .coupon-country{
              width: 180px;
              background: #FFDFB9;
            }
            .limit-product-text{
              font-weight: initial;
              font-size: 22px;
            }
          }
        }
        &.four{
          padding: 0 90px;
          /deep/ .coupon-item{
            padding-top: 56px;
            width: 220px;
            height: 274px;
            margin-right: 20px;
            margin-bottom: 20px;
            background-image: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-5.png);
            &.disabled{
              background-image: url(https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-6.png);
              .coupon-country{
                background: rgba(255, 223, 185, 0.6);
              }
            }
            &:nth-child(4n){
              margin-right: 0px;
            }
            .coupon-country{
              width: 140px;
              background: #FFDFB9;
            }
            .limit-product-text{
              font-weight: initial;
              font-size: 22px;
            }
          }
        }
      }
    }

    .product-box{
      display: flex;
      flex-direction: column;
      width: 100%;
      .product-box-inner{
        width: 1120px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .product-title-img{
        width: 100%;
        height: 100%;
        margin: 0 auto;
      }
      .product-list{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .product-item-box{
          margin-bottom: 30px;
        }
        &.one{
          padding: 0 60px;
          .product-item-box{
            padding: 24px;
            display: flex;
            justify-content: flex-start;

          }
          /deep/ .product-bg{
            width: 230px;
          }
          /deep/ .product-info{
            flex: 1;
            padding-top: 0px;
            padding-bottom: 0px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          /deep/ .product-name{
            width: 300px;
          }
        }
        &.two{
          padding: 0 60px;
          .product-item-box{
            width: 485px;
            margin-right: 30px;
            &:nth-child(2n){
              margin-right: 0px;
            }
          }
        }
        &.three{
          padding: 0 60px;
          .product-item-box{
            width: 312px;
            margin-right: 30px;
            &:nth-child(3n){
              margin-right: 0px;
            }
          }
        }
      }
    }
  }
  </style>



// WEBPACK FOOTER //
// src/pages/activity/daily-activity/index.vue